/** Read total row count from admin list API envelopes (products, orders, etc.). */

function itemsOnPage(payload) {
  if (!payload || typeof payload !== 'object') return null;
  if (Array.isArray(payload.data)) return payload.data.length;
  if (Array.isArray(payload.products)) return payload.products.length;
  if (Array.isArray(payload.orders)) return payload.orders.length;
  if (Array.isArray(payload.items)) return payload.items.length;
  return null;
}

/** Reject `count` fields that mirror the current page size (common when limit=1). */
function isLikelyPageSizeNotTotal(n, payload, pagination) {
  if (!Number.isFinite(n) || n < 0) return true;
  const pg = pagination && typeof pagination === 'object' ? pagination : null;
  const limit = Number(pg?.limit ?? pg?.pageSize);
  const onPage = itemsOnPage(payload);
  if (onPage == null || !Number.isFinite(limit) || limit <= 0) return false;
  if (n !== onPage || n !== limit) return false;
  const totalPages = Number(pg?.totalPages ?? pg?.pages);
  if (Number.isFinite(totalPages) && totalPages > 1) return true;
  return false;
}

function readPaginationTotal(pagination, payload) {
  if (!pagination || typeof pagination !== 'object') return null;
  const candidates = [
    pagination.total,
    pagination.totalCount,
    pagination.totalDocs,
    pagination.totalItems,
    pagination.totalRecords,
  ];
  for (const raw of candidates) {
    const n = Number(raw);
    if (Number.isFinite(n) && n >= 0 && !isLikelyPageSizeNotTotal(n, payload, pagination)) {
      return n;
    }
  }
  const pageCount = Number(pagination.count);
  if (
    Number.isFinite(pageCount) &&
    pageCount >= 0 &&
    !isLikelyPageSizeNotTotal(pageCount, payload, pagination)
  ) {
    return pageCount;
  }
  return null;
}

export function extractAdminListTotal(payload) {
  if (!payload || payload.success === false) return null;

  const fromPagination = readPaginationTotal(payload.pagination, payload);
  if (fromPagination != null) return fromPagination;

  const topLevel = [payload.total, payload.totalCount];
  for (const raw of topLevel) {
    const n = Number(raw);
    if (Number.isFinite(n) && n >= 0 && !isLikelyPageSizeNotTotal(n, payload, payload.pagination)) {
      return n;
    }
  }

  const topCount = Number(payload.count);
  if (
    Number.isFinite(topCount) &&
    topCount >= 0 &&
    !isLikelyPageSizeNotTotal(topCount, payload, payload.pagination)
  ) {
    return topCount;
  }

  const nested = payload.data;
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    const innerTotal = readPaginationTotal(nested.pagination, payload);
    if (innerTotal != null) return innerTotal;

    for (const raw of [nested.total, nested.totalCount]) {
      const n = Number(raw);
      if (Number.isFinite(n) && n >= 0 && !isLikelyPageSizeNotTotal(n, payload, nested.pagination)) {
        return n;
      }
    }
  }

  const pg = payload.pagination;
  const totalPages = Number(pg?.totalPages ?? pg?.pages);
  const onPage = itemsOnPage(payload);
  if (
    Number.isFinite(totalPages) &&
    totalPages === 1 &&
    onPage != null &&
    onPage >= 0
  ) {
    return onPage;
  }

  return null;
}
